import { observable, action, computed, autorun, transaction } from 'mobx';
import api from '../api';

export class SearchBox {
	DELAY = 200;
	CURSE = [
    'хуй',
    'бля',
    'пидор'
  ];
	@observable data = [];
	@observable result = [];
	@observable more = '';
	@observable str = '';
	@observable resultShow = 0;
	@observable loading = false;
	@observable showClear = false;
	@observable showCurse = false;
	delayTimeout = null;
	@observable keyIndex = 0;

  // constructor() {
	 //  autorun(() => {
	 		
  //   })
  // }

  @action changeInput(str) {
  	const v = str;
    if (this.str === v) return;
    this.str = v;
    clearTimeout(this.delayTimeout);
    if (v.length && v.length >= 2) {
        this.delayTimeout = setTimeout(() => {
           this.load();
        }, this.DELAY);
    } else if (!v.length || (v.length && v.length < 2)) {
        this.data = [];
        this.changeResultShowState(false);
    }

    this.checkCurse();

    this._changeFillTypeState(!!v.length);
  }

  _changeFillTypeState (state) {
      if (this.showClear === state)
          return;
      this.showClear = state;
  }

  checkCurse() {
  	if (this.data.length === 0 && this.CURSE.indexOf(this.str.toLowerCase()) !== -1) {
        this.showCurse = true;
        this.changeResultShowState(true);
    } else if (!this.more) {
    		// this.changeResultShowState(false);
        this.showCurse = false;
    }
  }

  @action changeResultShowState(state) {
      if (this.resultShow === state)
          return;
      if (!state) {
          this.keyIndex = 0;
      }
      this.resultShow = state;
  }

  @action changeKeyIndex(index) {
      this.keyIndex = index;
  }

  @action load() {
  	this.loading = true;
  	return api.search.get(this.str).then(
			action(
				data => {
					this.data = data.result;
					this.more = data.more;
					this.printResult();
				})
			)
			.catch(action(err => {
			}))
			.finally(action(() => {
				this.loading = false;
			}));
  }

  printResult() {
  	if (this.data.length > 0) {
  		this.changeResultShowState(true);
  	}
    // data = data ? data : this.data;
    // more = more ? more : this.more;

    // var html = '';
    // var classExtend;
    // var counter = 0;
    // this.keyIndex = 0;

    // for (var i in data) {
    //     classExtend = '';

    //     if (data[i].cursor.begin !== false) {
    //         data[i].name = data[i].name.substr(0, data[i].cursor.begin)
    //                 + '<span class="cursor">'
    //                 + data[i].name.substr(data[i].cursor.begin, data[i].cursor.length)
    //                 + '</span>'
    //                 + data[i].name.substr(data[i].cursor.end, data[i].name.length - data[i].cursor.end);
    //     }

    //     if (i == this.keyIndex) {
    //         classExtend += ' selected';
    //     }
    //     if (data[i].type == 4) {
    //         classExtend += ' game';
    //     }

    //     var pre_name = '';
    //     var icon = '';
    //     if (data[i].live && data[i].type === 4) {
    //         pre_name = '<span class="live f-s-ico-live"></span>';
    //     } else if (data[i].date && data[i].type === 4) {
    //         pre_name = '<span class="date">' + data[i].date + '</span>';
    //     }

    //     if (!data[i].live) {
    //         icon = '<span class="icon-sport f-s-ico-' + data[i].sid + '"></span>';
    //     }

    //     html += '<a href="' + data[i].url + '" class="item' + classExtend + '">' + icon + pre_name + '<span class="name">' + data[i].name + '</span>' + '</a>';
    //     counter++;
    // }
    // if (more) {
    //     removeClass(this.Dom.loadMore, 'hidden');
    //     this.Dom.loadMore.innerHTML = '<span>Найдено ещё ' + more + ' ' + this.declOfNum(more, ['событие', 'события', 'событий']) + '. Уточните поиск</span>';
    // } else {
    //     addClass(this.Dom.loadMore, 'hidden');
    // }

    // var showCurse = false;
    // if (counter === 0 && this.curse.indexOf(this.value.toLowerCase()) !== -1) {
    //     removeClass(this.Dom.loadMore, 'hidden');
    //     this.Dom.loadMore.innerHTML = '<span>Мы вас любим. Уточните поиск</span>';
    //     showCurse = true;
    // } else if (!more) {
    //     addClass(this.Dom.loadMore, 'hidden');
    // }
    // this.Dom.wrapperResultInner.innerHTML = html;
    // this._changeRes
  }
}

export default new SearchBox();


// WEBPACK FOOTER //
// ./src/stores/searchStore.js